module.exports = __webpack_public_path__ + "img/c08_unitram_Normal_ua.e4ac5fd2.webp";